const imagesInit = () => {
  const imagesOptions = {
    spaceBetween: 20,
    loop: true
  };

  const images = new Swiper(".image-container", imagesOptions);

};

document.addEventListener("DOMContentLoaded", function () {
  imagesInit();
});
